(function () {
  'use strict';
  var bar = document.querySelector('[data-ways-service-actions]');
  if (!bar || bar.dataset.ready === 'true') return;
  bar.dataset.ready = 'true';
  var viewSent = false;
  var measurementId = 'G-TC7C6QQYWE';
  var pageBranch = bar.getAttribute('data-branch');
  var locale = bar.getAttribute('data-locale') === 'zh-CN' ? 'zh-CN' : 'en';
  var validBranches = ['holborn', 'beeston', 'both', 'partner'];
  function allowed() {
    try {
      return Boolean(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (_) { return false; }
  }
  function emit(name, branch, placement) {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    if (validBranches.indexOf(branch) === -1) branch = 'both';
    // Only generic interaction counts. Never send link text, health interests,
    // destination URLs, query strings, customer identifiers or form contents.
    // An explicit GA4 destination avoids broadcasting these events to Ads.
    try { window.gtag('event', name, {
      send_to: measurementId,
      branch: branch,
      placement: placement,
      language: locale,
      page_location: 'https://wayspharmacy.co.uk/pages/pharmacy-services',
      page_title: 'Pharmacy services',
      page_referrer: '',
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      transport_type: 'beacon'
    }); } catch (_) { return false; }
    return true;
  }
  function view() {
    if (!viewSent) viewSent = emit('ways_service_view', pageBranch, 'page');
  }
  function isPageContact(link) {
    return bar.contains(link) || Boolean(link.closest('#main-content .page-content'));
  }
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || !isPageContact(link)) return;
    var href = link.getAttribute('href') || '';
    var placement = bar.contains(link) ? 'mobile_bar' : 'page';
    if (href === 'tel:+442081067084') emit('ways_call_holborn', 'holborn', placement);
    else if (href === 'tel:+441159255584') emit('ways_call_beeston', 'beeston', placement);
    else if (href === 'https://app.nuumad.co.uk/book-an-appointment/pvesbfow6t') emit('ways_booking_open', 'holborn', placement);
    else if (href.indexOf('https://book.better2know.com/partners/') === 0) emit('ways_booking_open', 'partner', placement);
  }, { capture: true, passive: true });
  bar.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    target.scrollIntoView({ behavior: 'auto', block: 'start' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
  var viewTimers = [];
  function scheduleView() {
    viewTimers.forEach(function (timer) { window.clearTimeout(timer); });
    viewTimers = [];
    view();
    // Consent can arrive long after page load and before Google's tag is ready.
    if (!viewSent) viewTimers = [1200, 3500, 8000].map(function (delay) { return window.setTimeout(view, delay); });
  }
  document.addEventListener('visitorConsentCollected', scheduleView);
  scheduleView();
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) scheduleView(); });
  }
})();
